import React from 'react'

export function hasTextChild(children: React.ReactNode): boolean {
  return React.Children.toArray(children).some(child => {
    if (typeof child === "string") return child.trim().length > 0
    if (typeof child === "number") return true
    if (React.isValidElement(child)) {
      return hasTextChild(child.props.children)
    }
    return false
  })
}
